export type currentLocation = string;

export type Sky = '맑음' | '구름많음' | '흐림';
export type PrecipitationType = "비" | "비와 눈" | "눈" | "소나기" | null;

export interface WeatherAPIResult {
    "baseDate": string;
    "baseTime": string;
    "category": string;
    "fcstDate": string;
    "fcstTime": string;
    "fcstValue": string;
    "nx": number;
    "ny": number;
};

// export type WeatherAPIResultNumberCategory = "TMP" | "SKY" | "PTY" | "PCP" | "TMX" | "TMN" | "PDP" | "WSD";
// export const WeatherAPIResultNumberCategory = "TMP" || "SKY" || "PTY" || "PCP" || "TMX" || "TMN" || "PDP" || "WSD";

export interface Weather {
    curTemperature: number;
    maxTemperature: number;
    minTemperature: number;
    sky: Sky;
    precipitationType: PrecipitationType;
    precipitation: number | null;
    precipitationPercentage: number;
    windSpeed: number;
};

export enum Weekday {
    "일요일",
    "월요일",
    "화요일",
    "수요일",
    "목요일",
    "금요일",
    "토요일",
};
export type Children = React.ReactNode;